import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminNavTabs.css';

/** Переключатель «Страницы» / «Медиатека» в шапке админки */
export default function AdminNavTabs() {
  return (
    <nav className="admin-nav-tabs" aria-label="Разделы админки">
      <NavLink
        to="/admin"
        end
        className={({ isActive }) => `admin-nav-tab${isActive ? ' active' : ''}`}
      >
        Страницы
      </NavLink>
      <NavLink
        to="/admin/media"
        className={({ isActive }) => `admin-nav-tab${isActive ? ' active' : ''}`}
      >
        Медиатека
      </NavLink>
    </nav>
  );
}
